import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useWsEvent } from '@/hooks/use-websocket';
/**
 * Staff-facing Pi OCR health indicator. Hidden while healthy to keep the
 * header clean; shows amber ("OCR loading") when the Pi is reachable but
 * the model isn't loaded, and red ("OCR down") when it can't be reached.
 *
 * Drives off the `ocr.pi_health_changed` WS event — purely push-based.
 */
export function PiHealthDot({ className = '' }) {
    const [health, setHealth] = useState(null);
    useWsEvent('ocr.pi_health_changed', (evt) => {
        setHealth(evt.payload);
    });
    if (!health)
        return null;
    if (health.reachable && health.modelLoaded)
        return null;
    const isAmber = health.reachable && !health.modelLoaded;
    const color = isAmber ? 'bg-amber-500' : 'bg-red-500';
    const label = isAmber ? 'OCR loading' : 'OCR down';
    const title = health.reachable
        ? 'Receipt OCR Pi reachable but model not loaded'
        : `Receipt OCR Pi unreachable${health.error ? `: ${health.error}` : ''}`;
    return (_jsxs("span", { className: `inline-flex items-center gap-1.5 text-xs text-muted-foreground ${className}`, title: title, "aria-label": title, children: [_jsx("span", { className: `h-2 w-2 rounded-full ${color}` }), _jsx("span", { className: "hidden sm:inline", children: label })] }));
}
export default PiHealthDot;
